import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import Store from "./scripts/Store/Readux/Store.js";
import { ThemeContextProvider } from "./scripts/Contexts/themeContext.js";
import App from "./scripts/App/App.js";
import "./index.css";
import './scripts/Styles/styles.scss';

const root = ReactDOM.createRoot(
  document.getElementById("root") || document.createElement("div")
);

if (module.hot) {
  module.hot.accept();
}

root.render(
  <Provider store={Store}>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </Provider>
);
